import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CompareDomainContextService {
  private readonly selectedCompareDomainSubject = new BehaviorSubject<string | null>(null);

  readonly selectedCompareDomain$ = this.selectedCompareDomainSubject.asObservable();

  get selectedCompareDomain(): string | null {
    return this.selectedCompareDomainSubject.value;
  }

  setSelectedCompareDomain(domain: string | null | undefined) {
    const normalized = this.normalizeDomain(domain);
    if (normalized === this.selectedCompareDomainSubject.value) {
      return;
    }
    this.selectedCompareDomainSubject.next(normalized);
  }

  reset() {
    this.selectedCompareDomainSubject.next(null);
  }

  private normalizeDomain(value: string | null | undefined): string | null {
    const normalized = (value || '')
      .toLowerCase()
      .trim()
      .replace(/^https?:\/\//, '')
      .replace(/^www\./, '')
      .split('/')[0]
      .split('?')[0]
      .split('#')[0]
      .split(':')[0]
      .trim();

    return normalized || null;
  }
}
